import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import React from 'react';
import { LMSLogo } from '../LMSLogo';
import { SignInButton } from '../SignInButton';
import { SignOutButton } from '../SignOutButton';
import css from './header.module.scss';

export const Header = () => {
  return (
    <header
      id="header"
      data-testid="header"
      className={css.header}
    >
      <div className={css.innerContainer}>
        <div className={css.logo}>
          <LMSLogo id="logo" data-testid="logo" />
          <span className={css.text}>You are in Consent Portal</span>
        </div>
        <UnauthenticatedTemplate>
          <SignInButton />
        </UnauthenticatedTemplate>
        <AuthenticatedTemplate>
          <SignOutButton />
        </AuthenticatedTemplate>
      </div>
    </header>
  );
};